import * as yup from 'yup'

/** One more file than the route's multer `maxCount` is a 400, so the limit is checked here. */
export const buildStepFilesValidator = (maxFiles: number) => {
  const message = maxFiles === 1 ? 'Attach a file' : `Attach 1 to ${maxFiles} files`

  return yup.object({
    files: yup
      .mixed<File[]>()
      .nullable()
      .test('files-count', message, (value) => {
        const count = Array.isArray(value) ? value.length : 0

        return count >= 1 && count <= maxFiles
      }),
  })
}
